export default "__VITE_ASSET__CcfLp$Pd__"